<script setup lang="ts">
import { ref } from "vue";
import { getViewportSize } from "@zyzgroup/core-web";
import Pop from "./Pop.vue";
import Button from "../form/Button.vue";
import Box from "../base/Box.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Pop, Button, Box },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    gap?: number;
    global?: boolean;
    closeWhenClickOverlay?: boolean;
  }>(),
  {
    gap: 10,
    global: true,
    closeWhenClickOverlay: true
  }
);

const buttonRef = ref();

const left = ref(0);
const top = ref(0);
let buttonLeft = 0;
let buttonTop = 0;
let buttonWidth = 0;
let contentWidth = 0;
let contentHeight = 0;

const popOpen = () => {
  const rect = buttonRef.value.getRect();
  buttonLeft = rect.x;
  buttonTop = rect.y;
  buttonWidth = rect.width;
  computeLocation();
};

const contentResize = (box) => {
  contentWidth = box.rect.width;
  contentHeight = box.rect.height;
  computeLocation();
};

const computeLocation = () => {
  const viewport = getViewportSize();
  left.value = Math.max(
    props.gap,
    Math.min(
      buttonLeft + buttonWidth + props.gap,
      viewport.width - contentWidth - props.gap
    )
  );
  top.value = Math.max(
    props.gap,
    Math.min(buttonTop, viewport.height - contentHeight - props.gap)
  );
};

const popRef = ref();
function open() {
  popRef.value?.open();
}
function close() {
  popRef.value?.close();
}

defineExpose({ open, close });
</script>

<template>
  <div>
    <Box
      ref="buttonRef"
      class="popover-button"
      display-type="shrink"
      @throttleClick="open"
    >
      <slot name="button">
        <Button>popover</Button>
      </slot>
    </Box>
    <Pop
      ref="popRef"
      direction-from="absolute"
      :pop-left="left + 'px'"
      :pop-top="top + 'px'"
      :global="props.global"
      :closeWhenClickOverlay="props.closeWhenClickOverlay"
      @open="popOpen"
    >
      <Box
        displayType="shrink"
        @resize="contentResize"
      >
        <slot name="panel">
          <div>...</div>
        </slot>
      </Box>
    </Pop>
  </div>
</template>

<style scoped></style>
